(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hfx-video-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      var stage = root.querySelector('[data-hfxv-stage]'),
        list = root.querySelector('.hfxv__list');
      if (!stage || !list) return;
      function embed(id) {
        stage.innerHTML =
          '<iframe src="https://www.youtube-nocookie.com/embed/' +
          id +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1" title="YouTube-video" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      }
      function sync() {
        if (window.innerWidth > 989) list.style.setProperty('--hfxv-h', stage.offsetHeight + 'px');
      }
      sync();
      window.addEventListener('resize', sync);
      stage.addEventListener('click', function (e) {
        var b = e.target.closest('.hfxv__poster');
        if (b) embed(b.dataset.id);
      });
      root.querySelectorAll('.hfxv__item').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('.hfxv__item').forEach(function (x) {
            x.removeAttribute('aria-current');
          });
          btn.setAttribute('aria-current', 'true');
          embed(btn.dataset.id);
          if (window.innerWidth <= 989) stage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    }
    function initAll() {
      document.querySelectorAll('.hfxv').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
